// extracted by mini-css-extract-plugin
module.exports = {"list":"MulticardList_list__JOGOw"};